import React from 'react';

import styled from 'styled-components';

import CdnImage from '~/shared/components/CdnImage';
import { mobile, useBreakpoint } from '~/techstyle-shared/react-components';
import { FormattedMessage } from '~/techstyle-shared/react-intl';

const Wrapper = styled.div`
  padding: 60px 0;

  ${mobile`
    padding: 60px 20px;
  `};
`;

const Header = styled.div`
  font-weight: bold;
  font-size: 30px;
  line-height: 37px;
  color: ${({ theme }) => theme.colors.textDefault};
  text-align: center;
`;

const ContentWrapper = styled.div`
  width: 70%;
  margin: auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  ${mobile`
    width: 100%;
  `};
`;

const GoalContainer = styled.div`
  width: 33%;
  padding-top: 15px;
  text-align: center;

  ${mobile`
    width: 45%;
  `};
`;

const GoalImage = styled.div`
  width: 73px;
  height: 73px;
  margin: auto;
  background: #eaf5f7;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const GoalTitle = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 2px;
  color: ${({ theme }) => theme.colors.textDefault};
  margin: 12px 0;
`;

const GoalCopy = styled.div`
  width: 80%;
  margin: auto;
  font-size: 14px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.sublabelBlack};
  font-family: neue-haas-grotesk-text;
`;

export default function FitAppPageGoals() {
  const { isMobile } = useBreakpoint();

  let goals = [
    <GoalContainer key="1">
      <GoalImage>
        <CdnImage path="30day-icon.png" localize="fitness_app" alt="" />
      </GoalImage>
      <GoalTitle>
        <FormattedMessage
          defaultMessage="30-DAY PROGRAMS"
          id="fitness_app.goal_1_title"
        />
      </GoalTitle>
      <GoalCopy>
        <FormattedMessage
          defaultMessage="Expertly designed to drive results"
          id="fitness_app.goal_1_copy"
        />
      </GoalCopy>
    </GoalContainer>,
    <GoalContainer key="2">
      <GoalImage>
        <CdnImage path="caret-icon.png" localize="fitness_app" alt="" />
      </GoalImage>
      <GoalTitle>
        <FormattedMessage
          defaultMessage="ON-DEMAND CLASSES"
          id="fitness_app.goal_2_title"
        />
      </GoalTitle>
      <GoalCopy>
        <FormattedMessage
          defaultMessage="Try 10 different categories like HIIT, yoga & more"
          id="fitness_app.goal_2_copy"
        />
      </GoalCopy>
    </GoalContainer>,
    <GoalContainer key="3">
      <GoalImage>
        <CdnImage path="selfguided-icon.png" localize="fitness_app" alt="" />
      </GoalImage>
      <GoalTitle>
        <FormattedMessage
          defaultMessage="SELF-GUIDED SESSIONS"
          id="fitness_app.goal_3_title"
        />
      </GoalTitle>
      <GoalCopy>
        <FormattedMessage
          defaultMessage="Strengthen specific muscle groups"
          id="fitness_app.goal_3_copy"
        />
      </GoalCopy>
    </GoalContainer>,
    <GoalContainer key="4">
      <GoalImage>
        <CdnImage path="meditiation-icon.png" localize="fitness_app" alt="" />
      </GoalImage>
      <GoalTitle>
        <FormattedMessage
          defaultMessage="MEDITATIONS"
          id="fitness_app.goal_4_title"
        />
      </GoalTitle>
      <GoalCopy>
        <FormattedMessage
          defaultMessage="Reduce stress, anxiety & more"
          id="fitness_app.goal_4_copy"
        />
      </GoalCopy>
    </GoalContainer>,
    <GoalContainer key="5">
      <GoalImage>
        <CdnImage path="star-icon.png" localize="fitness_app" alt="" />
      </GoalImage>
      <GoalTitle>
        <FormattedMessage
          defaultMessage="NEW CLASSES WEEKLY"
          id="fitness_app.goal_5_title"
        />
      </GoalTitle>
      <GoalCopy>
        <FormattedMessage
          defaultMessage="100s of workouts(& counting!) to choose from"
          id="fitness_app.goal_5_copy"
        />
      </GoalCopy>
    </GoalContainer>,
    <GoalContainer key="6">
      <GoalImage>
        <CdnImage path="challenge-icon.png" localize="fitness_app" alt="" />
      </GoalImage>
      <GoalTitle>
        <FormattedMessage
          defaultMessage="CHALLENGES"
          id="fitness_app.goal_6_title"
        />
      </GoalTitle>
      <GoalCopy>
        <FormattedMessage
          defaultMessage="Unlock discounts & points"
          id="fitness_app.goal_6_copy"
        />
      </GoalCopy>
    </GoalContainer>,
  ];
  if (isMobile) {
    goals = [goals[1], goals[0], goals[2], goals[4], goals[3], goals[5]];
  }

  return (
    <Wrapper>
      <Header>
        <FormattedMessage
          defaultMessage="Achieve Your Goals"
          id="fitness_app.achieve_goals"
        />
      </Header>
      <ContentWrapper>{goals}</ContentWrapper>
    </Wrapper>
  );
}
